import { StyleSheet } from 'aphrodite';
import constants from '../../../constants/styles';
let {
  PLACEHOLDER_COLOR,
  WORKFLOWS_BORDER_COLOR,
  WORKFLOWS_HEADER_BG_COLOR,
  FLAT_BUTTON_COLOR
} = constants;

let styles = {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justifyContent: 'center',
    height: '100%'
  },
  noTriggers: {
    alignItems: 'center',
    flexDirection: 'column'
  },
  icon: {
    color: PLACEHOLDER_COLOR,
    fontSize: '6em',
    marginBottom: 45
  },
  text: {
    fontSize: '1.2em',
    padding: 3
  },
  btn: {
    textTransform: 'capitalize',
    marginTop: 30
  },
  trigger: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  },
  separator: {
    height: 50,
    width: 1,
    borderLeft: `1px solid ${WORKFLOWS_BORDER_COLOR}`
  },
  addAction: {
    fontSize: '0.85em',
    fontWeight: 500,
    textTransform: 'capitalize',
    color: FLAT_BUTTON_COLOR,
    backgroundColor: WORKFLOWS_BORDER_COLOR,
    borderRadius: 5,
    padding: '5px 10px',
    marginTop: 10,
    ':hover': {
      backgroundColor: WORKFLOWS_HEADER_BG_COLOR
    }
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/data/triggerlist/TriggerList.styles.js